import { useEffect } from 'react'
import Pagination from 'components/pagination/Pagination'
import Button from 'components/form/Button'
import Table from 'components/table/Table'
import NoneAnchor from 'components/NoneAnchor'
import Moment from 'react-moment'
import { dateformat } from 'utils'
import { BULK_STATUS } from 'features/bulk/BulkCodes'
import { useDispatch, useSelector } from 'react-redux'
import { fail } from 'features/toast/Toast'
import {
  cancelKeywordPlanner,
  fetchKeywordPlannerFile,
  fetchKeywordPlannerList,
  reset,
  setPage,
} from 'features/bulk/keywordPlanner/keywordUploadSlice'
import {
  hideKeywordUploadModal,
  showKeywordUploadModal,
} from 'features/bulk/keywordPlanner/keywordUploadModalSlice'
import KeywordUploadModal from 'features/bulk/keywordPlanner/KeywordUploadModal'

const KeywordUpload = () => {
  const dispatch = useDispatch()
  const {
    isLoading,
    content,
    totalElements,
    page,
    size,
    disabledCancel,
    disabledDownload,
  } = useSelector(state => state.bulk.keywordUpload)

  useEffect(() => {
    dispatch(fetchKeywordPlannerList())
  }, [dispatch, page])

  useEffect(
    () => () => {
      dispatch(reset())
      dispatch(hideKeywordUploadModal())
    },
    [dispatch]
  )

  const showModal = () => {
    dispatch(showKeywordUploadModal())
  }

  const handleRefresh = () => {
    dispatch(fetchKeywordPlannerList())
  }

  const handlePageChange = v => dispatch(setPage(v))

  const handleCancelKeywordPlanner = async id => {
    const { error, payload } = await dispatch(cancelKeywordPlanner(id))
    if (error) {
      fail(payload.errorMessage)
    }
    dispatch(fetchKeywordPlannerList())
  }

  const handleFileDownload = async id => {
    const { error, payload } = await dispatch(fetchKeywordPlannerFile(id))
    if (error) {
      fail(payload.errorMessage)
    } else {
      window.open(`${payload.url}&download`)
    }
  }

  return (
    <>
      <ul className="list_append">
        <li>대량 키워드의 예상실적 결과를 파일로 다운로드 하실 수 있습니다.</li>
        <li>
          대량 관리를 통한 작업 시간은 사용량과 데이터 크기에 따라 유동적일 수
          있으며, 대량 관리 내역은 최근 3개월까지만 제공합니다.
        </li>
      </ul>
      <div className="ad_managebox">
        <div className="managebox_tit">
          <strong className="tit_box">
            총 업로드 목록 <em className="fc_emph">{totalElements}</em>
          </strong>
          <div className="f_left">
            <Button primary onClick={showModal}>
              <span className="img_comm ico_add" />
              업로드 등록하기
            </Button>
          </div>
          <div className="f_right">
            <Button line onClick={handleRefresh} disabled={isLoading}>
              새로고침
            </Button>
          </div>
        </div>
        <div className="tblg2_wrap">
          <Table
            className="tbl_g2"
            caption="업로드 목록 표"
            loading={isLoading}
            emptyMessage={
              <>
                등록된 업로드 목록이 없습니다.
                <br />
                <NoneAnchor className="link_txt" onClick={showModal}>
                  업로드 등록하기
                </NoneAnchor>
                를 클릭하여 새로운 업로드 유형을 생성하세요.
              </>
            }>
            <Table.Head>
              <Table.Column title="등록일시" width={153} />
              <Table.Column title="파일명" />
              <Table.Column title="처리자" width={249} />
              <Table.Column title="상태" width={150} />
              <Table.Column title="완료일시" width={145} />
              <Table.Column title="처리결과" width={85} className="align_c" />
            </Table.Head>
            <Table.Body>
              {content.map(
                ({
                  id,
                  name,
                  actor,
                  status,
                  fileUrl,
                  createdDate,
                  processedDate,
                }) => (
                  <Table.Row key={id} rowId={id}>
                    <td>
                      <div className="inner_tbl">
                        <Moment format={dateformat}>{createdDate}</Moment>
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        <a href={`${fileUrl}&download`} className="link_txt">
                          {name}
                        </a>
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">{actor}</div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        <p className="ad_state">
                          <span className={`ico_${BULK_STATUS[status].icon}`}>
                            DOWNLOAD_STATUS[status].icon
                          </span>
                          {BULK_STATUS[status].text}
                          {status === BULK_STATUS.WAITING.name && (
                            <Button
                              line
                              size="small"
                              onClick={() => handleCancelKeywordPlanner(id)}
                              disabled={disabledCancel}>
                              취소
                            </Button>
                          )}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        {processedDate && (
                          <Moment format={dateformat}>{processedDate}</Moment>
                        )}
                      </div>
                    </td>
                    <td className="align_c">
                      <div className="inner_tbl">
                        <div className="wrap_btn">
                          {status === BULK_STATUS.PROCESSED.name && (
                            <Button
                              size="small"
                              disabled={disabledDownload}
                              onClick={() => {
                                handleFileDownload(id)
                              }}>
                              다운로드
                            </Button>
                          )}
                        </div>
                      </div>
                    </td>
                  </Table.Row>
                )
              )}
            </Table.Body>
          </Table>
        </div>
        {totalElements > 0 && (
          <div className="paging_wrap">
            <div className="inner_paging">
              <Pagination
                current={page}
                total={totalElements}
                size={size}
                onChange={handlePageChange}
              />
            </div>
          </div>
        )}
      </div>
      <KeywordUploadModal />
    </>
  )
}
export default KeywordUpload
